// Supabase Bağlantı Test Fonksiyonu
import { supabase } from '../services/supabase'

export const testConnection = async () => {
  console.log('=== Supabase Bağlantı Testi ===')
  
  try {
    // 1. Supabase client kontrolü
    console.log('1. Supabase URL:', process.env.REACT_APP_SUPABASE_URL)
    console.log('2. Supabase Key var mı:', !!process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY)
    console.log('2b. Supabase Key uzunluğu:', process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY?.length || 0)
    
    // 2. Basit query testi
    console.log('3. Roles tablosunu test ediyorum...')
    const { data: roles, error: rolesError } = await supabase
      .from('roles')
      .select('*')
      .limit(1)
    
    if (rolesError) {
      console.error('❌ Roles query hatası:', rolesError)
      return { success: false, error: rolesError }
    }
    console.log('✅ Roles query başarılı:', roles?.length, 'rol bulundu')
    
    // 3. Users tablosu testi (RLS kontrolü)
    console.log('4. Users tablosunu test ediyorum...')
    const { data: users, error: usersError } = await supabase
      .from('users')
      .select('id, email, is_active')
      .limit(1)
    
    if (usersError) {
      console.error('❌ Users query hatası:', usersError)
      console.error('   Hata kodu:', usersError.code)
      console.error('   Hata mesajı:', usersError.message)
      return { success: false, error: usersError }
    }
    console.log('✅ Users query başarılı:', users?.length, 'kullanıcı bulundu')
    
    // 4. Login testi (admin kullanıcısı)
    console.log('5. Login testi yapıyorum...')
    const { data: loginTest, error: loginError } = await supabase
      .from('users')
      .select('id, email, password, is_active')
      .eq('email', 'admin@meb.gov.tr')
      .eq('is_active', true)
      .single()
    
    if (loginError) {
      console.error('❌ Login test hatası:', loginError)
      return { success: false, error: loginError }
    }
    
    if (loginTest) {
      console.log('✅ Login test başarılı!')
      console.log('   Email:', loginTest.email)
      console.log('   Şifre var mı:', !!loginTest.password)
      console.log('   Aktif mi:', loginTest.is_active)
    } else {
      console.warn('⚠️ Login test: Kullanıcı bulunamadı')
    }
    
    // 5. RLS durumu kontrolü
    console.log('6. RLS durumu kontrol ediliyor...')
    const { error: rlsError } = await supabase
      .from('users')
      .select('count')
      .limit(1)
    
    if (rlsError && (rlsError.code === '42501' || rlsError.message?.includes('permission'))) {
      console.error('❌ RLS aktif veya permission hatası!')
      console.error('   Lütfen şu komutu çalıştırın: ALTER TABLE users DISABLE ROW LEVEL SECURITY;')
      return { success: false, error: rlsError, rlsEnabled: true }
    }
    
    console.log('✅ Tüm testler başarılı!')
    return { 
      success: true, 
      roles: roles?.length || 0,
      users: users?.length || 0,
      loginUser: loginTest ? 'Bulundu' : 'Bulunamadı'
    }
    
  } catch (error) {
    console.error('❌ Test hatası:', error)
    return { success: false, error }
  }
}

